"use strict";
require('../checklist/CompanyChecklistService.js');

function uuidV4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0;
    var v = c === 'x' ? r : (r&0x3|0x8);

    return v.toString(16);
  });
}

function PublicationChecklistCheckboxDirective() {
  return {
    restrict: "A",
    templateUrl: "partials/company/publications/checklist/checklist-checkbox.html",
    scope: {
      c: "=publicationChecklistCheckbox",
      remove: "&onRemove",
      readOnly: "=",
      checkOnly: "=",
      editOnly: "="
    },
    link: function($scope, elem) {
      $scope.detailsVisible = false;
      $scope.showDetails = function() {
        if (!$scope.readOnly && !$scope.checkOnly) {
          $scope.detailsVisible = true;
          $scope.textCopy       = $scope.c.text;
        }
      };
      $scope.isUrlValid = function(url) {
        var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
        return regex.test(url);
      };
      $scope.getUrlName = function(url){
        var indexProtocol = url.indexOf('http://');
        var result, index;
        if(indexProtocol > -1){
          result = url.substring(indexProtocol+7, url.length);
          index = result.indexOf(' ');
          return url.substring(0, indexProtocol)+'<a class="checklist__link">'+result.substring(0, index > -1 ? index : result.length)+'</a>'+(index > -1 ? result.substring(index, result.length) : '');
        }else{
          indexProtocol = url.indexOf('https://');
          if(indexProtocol > -1){
            result = url.substring(indexProtocol+8, url.length);
            index = result.indexOf(' ');
            return url.substring(0, indexProtocol)+'<a class="checklist__link">'+result.substring(0, index > -1 ? index : result.length)+'</a>'+(index > -1 ? result.substring(index, result.length) : '');
          }else{
            indexProtocol = url.indexOf('www.');
            if(indexProtocol > -1){
              result = url.substring(indexProtocol, url.length);
              index = result.indexOf(' ');
              return url.substring(0, indexProtocol)+'<a class="checklist__link">'+result.substring(0, index > -1 ? index : result.length)+'</a>'+(index > -1 ? result.substring(index, result.length) : '');
            }else{
              return url;
            }
          }
        }
      };
      $scope.getUrl = function(url){
        var indexProtocol = url.indexOf('http://');
        var result, index;
        if(indexProtocol > -1){
          result = url.substring(indexProtocol, url.length);
          index = result.indexOf(' ');
          return result.substring(0, index > -1 ? index : result.length);
        }else{
          indexProtocol = url.indexOf('https://');
          if(indexProtocol > -1){
            result = url.substring(indexProtocol, url.length);
            index = result.indexOf(' ');
            return result.substring(0, index > -1 ? index : result.length);
          }else{
            indexProtocol = url.indexOf('www.');
            if(indexProtocol > -1){
              result = url.substring(indexProtocol, url.length);
              index = result.indexOf(' ');
              return 'http://'+result.substring(0, index > -1 ? index : result.length);
            }else{
              return url;
            }
          }
        }
      };
      $scope.abort = function() {
        $scope.textCopy       = "";
        $scope.detailsVisible = false;
      };
      $scope.save = function() {
        if ($scope.readOnly || $scope.checklist) {
          return;
        }
        if ($scope.textCopy !== "") {
          $scope.c.text = $scope.textCopy;
          $scope.$emit('checklistUpdating');
        }
        $scope.abort();
      };

      $scope.toggleItemChecklist = function() {
        if ($scope.readOnly || $scope.editOnly) {
          return;
        }

        $scope.c.checked = !$scope.c.checked;
        $scope.$emit('checklistUpdating');
        
      };

      var inputElm = elem.find('input');
      inputElm.on("keydown keypress", function (event) {
        //The checklist will be saved if user press Enter key
        if(event.which === 13) {
          if ($scope.textCopy) {
            $scope.$apply(function (){
                  $scope.save();
            });
          }
          event.preventDefault();
        }
      });
    }
  };
}

function PublicationChecklistDirective(CompanyChecklistService, $stateParams, $window, $rootScope, $modal, CompanyUserService) {
  return {
    restrict: "EA",
    templateUrl: function (element, attrs) {
      if (attrs.type && attrs.type === 'admin') {
        return 'partials/company/checklist/checklist-directive.html';
      } else if (attrs.type && attrs.type === 'guest'){
        return 'partials/company-guest/checklist/checklist.html';
      } else {
        return 'partials/company/publications/checklist/checklist.html';
      }
    },
    scope: {
      disabled: "=checklistDisabled",
      delete: "&onDelete",
      readOnly: "=",
      checkOnly: "=",
      editOnly: "=",
      showCheckbox: "=",
      userPermissions: "="
    },
    require: "ngModel",
    link: function($scope, elem, attrs, model) {

      $scope.sortableOptions = {
        handle: '.dnd-handle'
      };
      var widthWindow;
      if(!$scope.readOnly && !$scope.checkOnly){
        widthWindow = angular.element($window).width();
        setTimeout(function(){
          if(widthWindow <= 807){
            angular.element(elem).find('.checkbox-item').removeClass('dnd-handle');
          }else{
            angular.element(elem).find('.checkbox-item').addClass('dnd-handle');
          }
        }, 1);
        angular.element($window).on('resize', function () {
          widthWindow = angular.element($window).width();
          if(widthWindow <= 807){
            angular.element(elem).find('.checkbox-item').removeClass('dnd-handle');
          }else{
            angular.element(elem).find('.checkbox-item').addClass('dnd-handle');
          }
        });
      }

      model.$render = function() {
        $scope.checklist = model.$viewValue;
        $scope.oldChecklist = angular.copy($scope.checklist);
        if ($scope.checklist.focus) {
          $scope.autoFocus = true;
        }
      };

      $scope.$watch("checklist", function(newData, oldData) {
        calcPercent();
        if(angular.equals(newData, oldData)) {
          return;
        }
        if (newData.data.length !== oldData.data.length) {
            $scope.$emit('checklistUpdating');
        }
      }, true);

      function calcPercent() {
        var count = 0;
        angular.forEach($scope.checklist.data, function(v){
          if (v.checked === true) {
            count++;
          }
        });
        $scope.progress = Math.round(count/$scope.checklist.data.length*100);
      }

      var inputElm = elem.find('.media__body input.checklist__input');
      inputElm.on("keydown keypress", function (event) {
        //The checklist will be saved if user press Enter key
        if(event.which === 13) {
          if ($scope.newText) {
            $scope.$apply(function (){
                  $scope.addCheckbox('', $scope.newText);
                  $scope.newText = '';
            });
          }
          event.preventDefault();
        }
      });

      $scope.saveChecklist = function() {
        return CompanyChecklistService.update({
          companyId: $stateParams.companyId
        }, $scope.checklist).$promise.then(function(){
          $scope.oldChecklist = angular.copy($scope.checklist);
        }, function(){
          $scope.checklist = angular.copy($scope.oldChecklist);
        });
      };

      $scope.$on("checklistUpdating", function() {
        if ($scope.readOnly) {
          return;
        }

        $scope.saveChecklist();
      }, true);

      $scope.addCheckbox = function(before, text) {
        var idx = $scope.checklist.data.indexOf(before);
        $scope.checklist.data.splice(idx < 0 ? $scope.checklist.data.length : idx, 0, {
          checked: false,
          id: uuidV4(),
          text:    typeof text === "string" ? text : "",
          order: $scope.checklist.data.length
        });
        if(!$scope.readOnly && !$scope.checkOnly){
          setTimeout(function(){
            widthWindow = angular.element($window).width();
            if(widthWindow <= 807){
              angular.element(elem).find('.checkbox-item').removeClass('dnd-handle');
            }else{
              angular.element(elem).find('.checkbox-item').addClass('dnd-handle');
            }
          }, 1);
        }
      };

      $scope.removeCheckbox = function(checkbox) {
        var idx = $scope.checklist.data.indexOf(checkbox);

        if(idx > -1) {
          $scope.checklist.data.splice(idx, 1);
        }
      };

      $scope.editingHeader = function() {
        if (!$scope.readOnly && !$scope.checkOnly) {
          $scope.headerCopy       = $scope.checklist.header;
          $scope.formVisible = true;
        }
      };

      $scope.abortHeader = function() {
        $scope.formVisible = false;
      };

      $scope.saveHeader = function() {
        $scope.checklist.header = $scope.headerCopy;
        $scope.abortHeader();
        $scope.$emit('checklistUpdating');
      };

      $scope.ndnMovedCallback = function() {
        $scope.$emit('checklistUpdating');
      };

      inputElm = elem.find('header input');
      inputElm.on("keydown keypress", function (event) {
        //The checklist will be saved if user press Enter key
        if(event.which === 13) {
          if ($scope.headerCopy) {
            $scope.$apply(function (){
              $scope.saveHeader();
            });
          }
          event.preventDefault();
        }
      });

      var modal;
      $scope.showConnectedModal = function() {
        $rootScope.loading = true;
        modal = $modal({
          scope: $scope,
          controller: ['$scope', 'connectedObjects', function($scope, connectedObjects){
            $scope.connectedObjects = connectedObjects;
          }],
          templateUrl: 'partials/company/publications/checklist/connected.html',
          show: false,
          resolve: {
            connectedObjects: ['CompanyChecklistService', '$stateParams', function(CompanyChecklistService, $stateParams) {
              return CompanyChecklistService.queryConnected({
                companyId: $stateParams.companyId,
                checklistID: $scope.checklist.id
              }).$promise;
            }]
          }
        });

        modal.$promise.then(function(){
          modal.show();
          $rootScope.loading = false;
        }, function() {
          $rootScope.loading = false;
        });
      };

      var nonWatchersPromise;
      $scope.nonWatchers = [];
      $scope.updateNonWatchers = function(filter) {      
        var p = CompanyUserService.query({companyId: $stateParams.companyId, q: filter, limit: 6}).$promise.then(function(users) {
          return users.filter(function(item) {
            return !$scope.checklist.watchers.some(function(watcher) {
              return item.id === watcher.id;
            });
          });
        }).then(function(nonWatchers) {
          if(nonWatchersPromise === p) {
            $scope.nonWatchers = nonWatchers;
          }
        });
        
        nonWatchersPromise = p;
      };
    }
  };
}

function ChecklistInitDirective(CompanyChecklistService, $stateParams, $popover) {
  return {
    restrict: "EA",
    require: "ngModel",
    scope: {
      objectRelativeType: "=?",
      objectRelativeId: "=?",
      access: "="
    },
    replace: true,
    link: function(scope, elem, attrs, model) {
      if (attrs.hasOwnProperty("wrapperClass")) {
        elem.addClass(attrs.wrapperClass);
      }

      if (!scope.objectRelativeType) {
        scope.objectRelativeType = 'PUBLICATION';
      }

      if (!scope.objectRelativeId) {
        scope.objectRelativeId = $stateParams.publicationId;
      }

      model.$render = function() {
        scope.checklists = model.$viewValue;
      };

      var DEFAULT_CHECKLIST = {
        object_relative_id: scope.objectRelativeId,
        header: "",
        data: [],
        object_relative_type: scope.objectRelativeType,
        focus: true
      };

      scope.checklist = angular.copy(DEFAULT_CHECKLIST);

      scope.autoFocus = false;

      scope.filter = {};

      var popover;
      scope.createChecklist = function() {
        scope.checklist.order = scope.checklists.length + 1;
        CompanyChecklistService.update({
          companyId: $stateParams.companyId
        }, scope.checklist, function(c){
          c.focus = true;
          scope.checklists.push(c);
          scope.checklist = angular.copy(DEFAULT_CHECKLIST);
          scope.filter.header = null;
          scope.checklistClone = null;
        });
        if (popover) {
          popover.$promise.then(popover.hide);
        }
      };

      scope.search = function() {
        scope.checklistClone = null;
        CompanyChecklistService.query({
          companyId: $stateParams.companyId,
          relativeID: $stateParams.companyId,
          header: scope.filter.header
        }).$promise.then(function(resp){
          scope.itemQuery = resp;
        });
      };

      scope.addChecklist = function(checklist) {
        scope.checklist.header = checklist.header;
        scope.filter.header = checklist.header;
        scope.checklistClone = checklist;
      };

      scope.cloneChecklist = function() {
        scope.checklist = angular.copy(scope.checklistClone);
        scope.checklist.object_relative_id = scope.objectRelativeId;
        scope.checklist.object_relative_type = scope.objectRelativeType;
        scope.checklist.parent_id = scope.checklist.id;
        delete scope.checklist.id;
        scope.createChecklist();
      };

      scope.popov = function(el){
        scope.itemQuery = [];
        if (!popover) {
          popover = $popover(angular.element(el.target), {
            placement: 'bottom',
            templateUrl: 'partials/company/publications/checklist/popover.html',
            autoClose: 1,
            scope: scope
          });
          popover.$promise.then(popover.show);
        } else {
          popover.$promise.then(popover.hide);
        }
      };
    },
    templateUrl: 'partials/company/publications/checklist/checklist-form.html'
  };
}

function CompanyChecklistDirective(checklistService, $stateParams, $modal, $translate) {
  return {
    restrict: "EA",
    require: "ngModel",
    scope: {
      accessType: "=",
      readOnly: "=",
      editOnly: "=",
      showCheckbox: "=",
      userPermissions: "="
    },
    replace: true,
    link: function($scope, elem, attrs, model) {
      $scope.sortableOptions = {
        handle: ' .dnd-handle'
      };

      model.$render = function() {
        $scope.checklists = model.$modelValue;
      };

      $scope.deleteChecklist = function(index, checklist) {
        checklistService.delete({
          companyId: $stateParams.companyId,
          checklistID: checklist.id
        }).$promise.then(function(){
          $scope.checklists.splice(index, 1);
        });
      };

      $scope.ndnMovedCallback = function() {
        setTimeout(function() {
          angular.forEach($scope.checklists, function(value, key){
            if ($scope.checklists[key].order !== key) {
              $scope.checklists[key].order = key;
              checklistService.update({
                companyId: $stateParams.companyId
              }, $scope.checklists[key]);
            }
          });
        }, 1);
      };

      var angularModal;
      $scope.showModalDeleteChecklist = function(index, checklist) {
         angularModal = $modal({
          scope: $scope,
          prefixEvent: "modalChecklist",
          controller: ['$scope', function($scope) {
            $scope.confirmName = $translate.instant('checklist.confirm-delete');
            $scope.activeDelete = function() {
              $scope.deleteChecklist(index, checklist);
            };
          }],
          templateUrl: 'partials/company/publications/detail/latest/confirm-delete.html',
          show: true,
        });
      };

      $scope.$on('modalChecklist.hide', function(){
        angularModal.destroy();
        angularModal = null;
      });
    },
    templateUrl: "partials/company/publications/checklist/checklists.html"
  };
}

angular.module("dokiv")
  .directive("publicationChecklist", ["CompanyChecklistService", "$stateParams", "$window", "$rootScope", "$modal", "CompanyUserService", PublicationChecklistDirective])
  .directive("checklistInitDirective", ["CompanyChecklistService", "$stateParams", "$popover", ChecklistInitDirective])
  .directive("publicationChecklistCheckbox", PublicationChecklistCheckboxDirective)
  .directive("companyChecklist", ["CompanyChecklistService", "$stateParams", "$modal", "$translate", CompanyChecklistDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/PublicationChecklistDirective.js
// module id = 390
// module chunks = 0